import { httpClient } from "./http-client";
import { NEW_API_ENDPOINTS } from "../../shared/constants/api";
import type {
  ApiResponseRouterInfoResponse,
  UpdateRouterRequest,
} from "../../shared/types/api";

export class RouterApiService {
  async updateRouter(
    routeId: number,
    request: UpdateRouterRequest,
  ): Promise<ApiResponseRouterInfoResponse> {
    const response = await httpClient.put<ApiResponseRouterInfoResponse>(
      NEW_API_ENDPOINTS.routerController.PUT(routeId),
      request,
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "라우터 수정에 실패했습니다.");
    }

    return response.data;
  }
}

export const routerApiService = new RouterApiService();
